module.exports = __webpack_public_path__ + "b2e6a71aa4eab670a784cf6d97f94945.pdf";